import React, { FC } from 'react'
import styled from 'styled-components'
import { PaddedContentStyled } from '../../styles/shared'
import WriteLikeNoOnesWatching from './writeLikeNoOnesWatching'
import KeepYourDataProtected from './keepYourDataProtected'
import { ScreenBreakpointSize } from '../../utils/enums'
import { getScreenBreakpointSize } from '../../utils/getScreenBreakpointSize'

const ContainerStyled = styled.div`
  display: flex;
  margin: var(--spacing-24) auto 0;
  max-width: var(--page-title-max-width);

  @media screen and (max-width: ${getScreenBreakpointSize(ScreenBreakpointSize.Medium)}) {
    display: block;
    margin-top: 0;
  }
`

const WriteProtected: FC = () => {
  return (
    <PaddedContentStyled>
      <ContainerStyled>
        <WriteLikeNoOnesWatching />
        <KeepYourDataProtected />
      </ContainerStyled>
    </PaddedContentStyled>
  )
}

export default WriteProtected
